import {
  GET_COMPONENT_USAGE_REQUESTED,
  GET_COMPONENT_USAGE_REJECTED,
  GET_COMPONENT_USAGE_FULLFILLED,
  CLEAR_COMPONENT_USAGE
} from './const';

/**
 * handle get component usage failure
 * @param {string} componentId - the id of the component
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const componentUsageFailure = (componentId, error) => ({
  type: GET_COMPONENT_USAGE_REJECTED,
  componentId,
  error
});

/**
 * Returns action for getting component usage
 * @param {string} componentId - object containing component Id.
 * @returns {object} action Object
 */
export const componentUsageRequest = componentId => ({
  type: GET_COMPONENT_USAGE_REQUESTED,
  componentId
});

/**
 * handle get component usage success
 * @param {string} componentId - the id of the component
 * @param {object} payload - the response payload of the successful call
 * @returns {object} an action object
 */
export const componentUsageSuccess = (componentId, payload) => ({
  type: GET_COMPONENT_USAGE_FULLFILLED,
  componentId,
  payload
});

/**
 * Returns action for clearing component usage
 * @returns {object} Clears AMP DATA
 */
export const clearComponentUsage = () => ({
  type: CLEAR_COMPONENT_USAGE
});
